import { useTranslation } from 'next-i18next';
import BasicSignUpLink from '@bridebook/web/app-basic/components/signup-link/basic-sign-up-link';

export const CoupleLoginButton = () => {
  const { t } = useTranslation('common');

  return (
    <BasicSignUpLink showLogin>
      <button data-name="landing-header-log-in" className="bcb bcx">
        {t('button.login')}
      </button>
    </BasicSignUpLink>
  );
};
